<template>
  <div>
    <OrdinaryRecord v-if="id" />
    <DaGongDeZhuRecord v-else />
  </div>
</template>

<script>
import DaGongDeZhuRecord from './components/DaGongDeZhuRecord.vue'
import OrdinaryRecord from './components/OrdinaryRecord.vue'
export default {
  components: {
    OrdinaryRecord,
    DaGongDeZhuRecord
  },
  data () {
    return {
      id: this.$route.query.id
    }
  }
}
</script>